import { render, staticRenderFns } from "./CategoryLabel.vue?vue&type=template&id=2860adfc&scoped=true"
import script from "./CategoryLabel.vue?vue&type=script&lang=js"
export * from "./CategoryLabel.vue?vue&type=script&lang=js"
import style0 from "./CategoryLabel.vue?vue&type=style&index=0&id=2860adfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860adfc",
  null
  
)

export default component.exports